import React from "react";
import { Grid, Typography, Box } from "@mui/material";

export const NotFound = () => {
  return (
    <Grid sx={{ paddingTop: "200px" }}>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div fontWeight="600" style={{ padding: "20px", fontWeight: "600" }}>
          <div style={{ fontWeight: "600", fontSize: "25px" }}>
            Page is not Found
          </div>
        </div>
      </Grid>
    </Grid>
  );
};


export const NotDataFound = (text) => {
  return (
    <Grid sx={{ paddingTop: "200px" }}>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div fontWeight="600" style={{ padding: "20px", fontWeight: "600" }}>
          <div style={{ fontWeight: "600", fontSize: "25px", fontFamily: "sans-serif" }}>
            {text}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};
